import React, { Suspense } from "react"

const AnimatedBackground = React.lazy(() => import("./AnimatedBackground"))

interface DeferredAnimatedBackgroundProps {
  skipIntro?: boolean
}

const DeferredAnimatedBackground: React.FC<DeferredAnimatedBackgroundProps> = props => {
  return (
    <Suspense fallback={null}>
      <AnimatedBackground {...props} />
    </Suspense>
  )
}

export default DeferredAnimatedBackground
